var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4194 13.6752H13.1916C13.6373 13.6752 14 13.3071 14 12.8555V12.0342C14 11.1284 13.2748 10.3932 12.3846 10.3927V7.11091C12.3846 4.79955 10.9615 2.77231 8.88462 1.98535V1.91323C8.88462 0.856385 8.04076 0 7 0C5.96035 0 5.11539 0.856901 5.11539 1.91323V1.98531C3.0385 2.77216 1.61538 4.79907 1.61538 7.11091C1.61538 7.11091 1.6149 10.3932 1.61595 10.3932C0.723871 10.3932 0 11.1287 0 12.0342V12.8555C0 13.3089 0.361466 13.6752 0.808378 13.6752H4.5806C4.65045 14.9711 5.70694 16 7 16C8.29306 16 9.34955 14.9711 9.4194 13.6752ZM8.33951 13.6752C8.27197 14.3663 7.69803 14.906 7 14.906C6.30197 14.906 5.72803 14.3663 5.66049 13.6752H8.33951ZM12.9231 12.5812H1.07692V12.0342C1.07692 11.7329 1.3187 11.4872 1.61595 11.4872C2.20982 11.4872 2.69231 10.9967 2.69231 10.3927V7.11091C2.69231 5.14797 3.97487 3.44162 5.80307 2.90594L6.19231 2.79189V1.91323C6.19231 1.46153 6.55471 1.09402 7 1.09402C7.44624 1.09402 7.80769 1.46084 7.80769 1.91323V2.7919L8.19691 2.90596C10.025 3.4417 11.3077 5.14845 11.3077 7.11091V10.3927C11.3077 10.9985 11.789 11.4872 12.3841 11.4872C12.6805 11.4872 12.9231 11.7331 12.9231 12.0342V12.5812Z",
    fill: "#B1C2CF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.74cc0080748df03ab6c78ff26e5546c0.svg";
export { ForwardRef as ReactComponent };